<script>
import moment from 'moment'

export default {
	props: {
		paymentData: Object,
		orderId: String,
	},
	data() {
		return {
			showToast: false,
			btnStatus: 'default',
		}
	},
	computed: {
		transferDateLimit() {
			const m = moment(this.paymentData.expiration_timestamp)
			const dateStr = m.locale('es-AR').format('LL')
			const [month, ...rest] = dateStr.split(' ')
			let esMonth
			const monthMap = {
				january: 'enero',
				february: 'febrero',
				march: 'marzo',
				april: 'abril',
				may: 'mayo',
				june: 'junio',
				july: 'julio',
				august: 'agosto',
				september: 'septiembre',
				october: 'octubre',
				november: 'noviembre',
				december: 'diciembre',
			}
			esMonth = monthMap[month.toLowerCase()]
			esMonth = esMonth.charAt(0).toUpperCase() + esMonth.slice(1)
			return [esMonth, ...rest].join(' ')
		},
	},
	methods: {
		async copyToClipboard(text) {
			await navigator.clipboard.writeText(text)
			this.showToast = true
			setTimeout(() => {
				this.showToast = false
			}, 3000)
		},
		async confirmPayment() {
			this.btnStatus = 'loading'
			await new Promise((resolve) => setTimeout(resolve, 5000))
			await this.$shopApi.post({
				url: `/talo-confirm-payment`,
				data: { orderId: this.orderId },
				onSuccess: () => this.$emit('payment-confirmed'),
				loading: (v) => (this.btnStatus = v ? 'loading' : 'default'),
				onError: () => {
					this.btnStatus = 'error'
				},
			})
		},
		moment,
	},
}
</script>

<template>
	<div>
		<div>
			Podes transferir a estos datos hasta el
			<b>{{ transferDateLimit }}</b>
		</div>
		<div>
			Quedan <b><TaloCountdown :target-date="paymentData.expiration_timestamp" /></b> para que caduque el
			pago.
		</div>
		<div class="talo-box">
			<div>Titular: {{ paymentData.user_info.full_name }}</div>
			<div class="font-2">CUIT: {{ paymentData.user_info.cuit }}</div>
		</div>
		<div
			class="talo-box talo-box--interactive"
			@click="copyToClipboard(paymentData.quotes[0].cvu || paymentData.quotes[0].address)"
		>
			<div class="d-flex justify-space-between">CVU <v-icon small>mdi-content-copy</v-icon></div>
			<div class="font-2">{{ paymentData.quotes[0].cvu || paymentData.quotes[0].address }}</div>
		</div>
		<div
			v-if="paymentData.quotes[0].alias"
			class="talo-box talo-box--interactive"
			@click="copyToClipboard(paymentData.quotes[0].alias)"
		>
			<div class="d-flex justify-space-between">Alias <v-icon small>mdi-content-copy</v-icon></div>
			<div class="font-2">{{ paymentData.quotes[0].alias }}</div>
		</div>
		<div class="talo-box talo-box--interactive" @click="copyToClipboard(paymentData.quotes[0].amount)">
			<div class="d-flex justify-space-between">Monto <v-icon small>mdi-content-copy</v-icon></div>
			<!-- <div class="font-2">${{ paymentData.quotes[0].amount }}</div> -->
			<PriceText
				class="font-2"
				:amount="Number(paymentData.quotes[0].amount)"
				:currency="paymentData.quotes[0].currency"
			/>
		</div>
		<IndeterminateProgressBtn
			v-model="btnStatus"
			default-color="cta"
			success-color="success"
			error-color="error"
			@click="confirmPayment"
			:error-duration="5000"
			block
			x-large
		>
			Ya realicé el pago
			<template #loading> Procesando Pago... </template>
			<template #success>
				<div></div>
			</template>
			<template #error>
				<v-icon left> mdi-close-thick </v-icon>
				Lo sentimos, ha ocurrido un error
			</template>
		</IndeterminateProgressBtn>
		<transition name="toast-slide">
			<div v-if="showToast" class="toast font-2">Copiado!</div>
		</transition>
	</div>
</template>

<style scoped lang="scss">
.talo-box {
	border: 1px solid #ccc;
	padding: 12px;
	margin: 16px 0;
	display: flex;
	flex-direction: column;
	gap: 8px;
	border: 1px solid #ccc;
	border-radius: 4px;

	&--interactive {
		cursor: pointer;

		&:hover {
			transform: scale(1.01);
			transition: transform 0.2s;
		}
	}
}

.toast {
	position: fixed;
	bottom: 16px;
	right: 16px;
	background-color: var(--success);
	color: var(--successtext);
	padding: 8px 16px;
	border-radius: 4px;
	opacity: 0.9;
	z-index: 1000;
}

.toast-slide-enter-active,
.toast-slide-leave-active {
	transition: all 0.3s ease;
}

.toast-slide-enter-from {
	transform: translateY(100%);
	opacity: 0;
}

.toast-slide-leave-to {
	transform: translateX(100%);
	opacity: 0;
}
</style>

